import React from 'react';

type LogOutIconProps = {
    size?: number;
    color?: string;
    className?: string;
};

const LogOutIcon: React.FC<LogOutIconProps> = React.memo((props) => {
    const {size, color, className} = props;

    return (
        <svg className={className && className} width={size || '32'} height={size || '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H12"
                stroke={color || 'currentColor' || '#1E1E20'}
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M21.3335 22.6667L28.0002 16L21.3335 9.33334" stroke={color || 'currentColor' || '#1E1E20'} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M28 16H12" stroke={color || 'currentColor' || '#1E1E20'} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
});

export default LogOutIcon;
